// src/components/listing/StarRating.js
// Étoiles avec vrais boutons (fix tap iOS) - style pro façon Play Store - NE PAS MODIFIER

import React, { useState } from 'react';

const StarRating = ({ rating = 0, size = 18, interactive = false, onChange }) => {
  const [hoverValue, setHoverValue] = useState(0);
  const displayValue = interactive && hoverValue > 0 ? hoverValue : rating;

  const styles = {
    container: { display: 'flex', gap: interactive ? '6px' : '2px' },
    starButton: (filled) => ({
      background: 'none',
      border: 'none',
      padding: interactive ? '4px' : '0',
      margin: 0,
      fontSize: `${size}px`,
      color: filled ? '#F5B301' : '#D1D5DB',
      cursor: interactive ? 'pointer' : 'default',
      lineHeight: 1,
      WebkitTapHighlightColor: 'transparent',
      touchAction: 'manipulation',
    }),
  };

  // Sur les étoiles interactives, on utilise de vrais <button> (pas des <span>)
  // pour éviter le bug iOS Safari où un élément avec onMouseEnter exige 2 taps
  if (interactive) {
    return (
      <div style={styles.container}>
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            style={styles.starButton(star <= displayValue)}
            onClick={() => onChange(star)}
            onMouseEnter={() => setHoverValue(star)}
            onMouseLeave={() => setHoverValue(0)}
            aria-label={`${star} étoile${star > 1 ? 's' : ''}`}
          >
            ★
          </button>
        ))}
      </div>
    );
  }

  // Affichage seul (non interactif) : simple, léger
  return (
    <div style={styles.container}>
      {[1, 2, 3, 4, 5].map((star) => (
        <span key={star} style={styles.starButton(star <= displayValue)}>★</span>
      ))}
    </div>
  );
};

export default StarRating;